__turbopack_context__.v({
  "accordionSlideOverwrite": "asthmaCanadaLogo-module-scss-module__BKtPrW__accordionSlideOverwrite",
  "fadeIn": "asthmaCanadaLogo-module-scss-module__BKtPrW__fadeIn",
  "fadeOut": "asthmaCanadaLogo-module-scss-module__BKtPrW__fadeOut",
  "image": "asthmaCanadaLogo-module-scss-module__BKtPrW__image",
  "logo": "asthmaCanadaLogo-module-scss-module__BKtPrW__logo",
  "scaleIn": "asthmaCanadaLogo-module-scss-module__BKtPrW__scaleIn",
  "scaleOut": "asthmaCanadaLogo-module-scss-module__BKtPrW__scaleOut",
  "zoomIn": "asthmaCanadaLogo-module-scss-module__BKtPrW__zoomIn",
  "zoomOut": "asthmaCanadaLogo-module-scss-module__BKtPrW__zoomOut",
});
